import { mq } from "@/constants/breakpoints";
import { darkColor, lightBlueColor, textColor } from "@/constants/colors";
import ArrowLeftIcon from "@/svg/ArrowLeftIcon";
import options from "@/utils/richTextOptions";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { css } from "@emotion/react";
import { useEffect, useRef, useState } from "react";
import HR from "../HR/HR";
import { BodyRegular14, H5Css, Heading } from "../Typography";

interface FAQItemProps {
  question: string;
  answer: any;
}

const FAQItem = ({ question, answer }: FAQItemProps) => {
  const panelRef = useRef<null | HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      panelRef.current!.style.maxHeight = panelRef.current!.scrollHeight + "px";
    } else {
      panelRef.current!.style.maxHeight = "0";
    }
  }, [isOpen]);

  return (
    <div>
      <div
        role="button"
        onClick={() => setIsOpen(!isOpen)}
        css={css`
          cursor: pointer;
          margin-top: 16px;
          margin-bottom: ${isOpen ? 0 : 16}px;
          padding-top: 20px;
          padding-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: margin 0.2s ease-in-out;
          gap: 8px;
        `}
      >
        <Heading
          level={3}
          css={css`
            color: ${darkColor};
            font-size: 18px;
            line-height: 23.4px;
            font-weight: 400;
            ${mq["lg"]} {
              ${H5Css}
            }
          `}
        >
          {question}
        </Heading>
        <ArrowLeftIcon
          css={css`
            min-width: 36px;
            color: ${lightBlueColor};
            transition: transform 0.2s ease-in-out;
            transform: rotate(${isOpen ? 270 : 180}deg);
          `}
        />
      </div>
      <div
        ref={panelRef}
        css={css`
          max-height: 0;
          overflow: hidden;
          margin-bottom: ${isOpen ? 36 : 0}px;
          transition: max-height 0.2s ease-in-out, margin 0.2s ease-in-out;
        `}
      >
        <BodyRegular14
          css={css`
            color: ${textColor};
          `}
        >
          {documentToReactComponents(answer, options())}
        </BodyRegular14>
      </div>
      <HR />
    </div>
  );
};

export default FAQItem;
